import { Component, OnInit } from '@angular/core';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-trending-page',
  templateUrl: './trending-page.component.html',
  styleUrls: ['./trending-page.component.scss'],
})
export class TrendingPageComponent implements OnInit {
  constructor(
    private api: MarketingApiService,
    private message: MessageService
  ) {
  }

  ngOnInit(): void {}

  articles: any[] = [];
  query = '';
  page = 0;
  pageSize = 5;
  hasMore = true;
  findMarketingArticles = async () => {
    let hasMore = true;
    this.page++;
    try {
      const r = await this.api.findMarketingArticles(
        this.query,
        this.page,
        this.pageSize
      );
      const list = r.data || [];
      this.articles = this.articles.concat(list);
      if (list.length < this.pageSize) {
        hasMore = false;
      }
    } catch (error) {
      this.message.open('网络错误');
    }
    return hasMore;
  };
}
